import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import ForgotPassword from '../Components/Forgotphonenumber'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
function Forgotpassword() {
        return (
                <>
                        <Combaintop />
                        <ForgotPassword />
                        <Combainbottom />
                </>);
}

export default Forgotpassword;